import templates from '../constant/templates'

export default {
  state: {
    chartTemplates: templates
  },
  getters: {
    chartTemplates: ({ chartTemplates }) => chartTemplates
  },
  actions: {
  },
  mutations: {
    setChartTemplates (state, val = []) {
      state.chartTemplates = Object.freeze(val)
    },
    addChartTemplates (state, val = []) {
      state.chartTemplates = Object.freeze([
        ...val,
        ...templates,
      ])
    }
  }
}
